import React, {useState, useEffect} from 'react';
import axios from 'axios';
import config from '../../config/apiConfig';
import "react-datepicker/dist/react-datepicker.css";
//alertas
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//loading
import BeatLoader from "react-spinners/BeatLoader";
import { css } from "@emotion/react";


//Utilidades
import FormatoMoneda from '../Utiles';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import es from 'date-fns/locale/es';
registerLocale('es', es)

function ReporteOperacionVendedor() {
//loading   
const [loading, setLoading] = useState(false);

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;


const [mensajeError, setMensajeError] = useState('');
const [datosJornada, setDatosJornada] = useState({})
const [usuario, setUsuario] = useState({})
const [resumen, setResumen] = useState({})
  

useEffect(()=>{
    const token = localStorage.getItem("token");
    axios.defaults.headers.common["token"] = token;
    GetDatosJornada();
   },[]);

{/*Busca datos de la jornada!*/}
async function GetDatosJornada(){
        
    let url =config.api_url+'/usuarios/jornada/incio/';
    setLoading(true);
    await axios.get(url).then(resp=>{
        console.log(resp)
        if (resp.data.completado){
             setDatosJornada(resp.data.datos);
             setUsuario(resp.data.datos.usuario);
             setResumen(resp.data.resumen);
             setLoading(false);
        }
        else{
            setLoading(false);
            toast.error(resp.mensaje);
        }    
     }).catch(error=>{
        setLoading(false);
        toast.error("Se ha generado un error al obtener datos de la jornada! ")          
    })

}
return (
    <div className="contenedorMantenedor">
        <br/>
        <ToastContainer/>
        
        <div className="col-md-12">
            <div className="d-flex justify-content-start">
                <a href='/reportes/home/'><i class="bi bi-arrow-left-short"></i> Reportes </a>   
            </div>
             <h2> <i className="bi bi-calculator"></i> Reporte Operación Vendedor</h2>
        </div>
        <br/>
        <div className='row'>
            <div className='col-12'>
                <div className="card" style={{width:"90%", marginLeft:"5%", marginRight:"5%"}}>
                        <div className="card-body">
                            <h5 className="card-title">Resumen</h5>
                           
                            <div className='row'>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Usuario</label>
                                        <input type='text' className='form-control' readOnly value ={usuario.nombre}/> 
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Caja</label>
                                        <input type='text' className='form-control' readOnly value ={datosJornada.sucursalNombre}/> 
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Horario de Inicio</label>
                                        <input type='text' className='form-control' readOnly value ={datosJornada.fecha_hora_inicio }/> 
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
       
        <br/>
        <BeatLoader color={config.color_loader} loading={loading} css={override} size={50} />
        <br/>
        <div className="row">
            <div className="col-md-12" style={{paddingLeft:"5%", paddingRight:"5%"}}>
                <div className="alert alert-warning"  hidden={mensajeError? false:true} role="alert">
                      {mensajeError}
                </div>
            </div>
        </div>
        {resumen!=={}?
        <div>
        <div className="row" style={{width:"90%", marginLeft:"5%", marginRight:"5%"}}>
            <div className="col-md-12" style={{paddingLeft:"5%", paddingRight:"5%"}}>
                 <label> <h3>Total ventas por medio de pago </h3> </label>
            </div> 
        </div>
        <div className="row" style={{width:"90%", marginLeft:"5%", marginRight:"5%"}}>
            <div className="col-md-12" style={{paddingLeft:"5%", paddingRight:"5%"}}>
                <table className="table table-striped">
                        <thead class="thead-dark">
                                <tr>
                                    <th scope="col">Item</th>    
                                    <th scope="col">Total</th>  
                                    <th scope="col">cantidad</th>  
                                       
                                </tr>
                        </thead>
                            <tbody>   
                                <tr> 
                                    <td>
                                        Total
                                    </td>
                                    <td>
                                        ${FormatoMoneda(resumen.totalVentas)}
                                    </td>
                                    <td>
                                        {resumen.cantidadVentas}
                                    </td>
                                        
                                </tr>
                                <tr> 
                                    <td>
                                        Efectivo
                                    </td>
                                    <td>
                                        ${FormatoMoneda(resumen.totalEfectivo)}
                                    </td> 
                                    <td>
                                        {resumen.cantidadEfectivo}
                                    </td>   
                                </tr>
                                <tr> 
                                    <td>
                                        Debito
                                    </td>
                                    <td>
                                        ${FormatoMoneda(resumen.totalDebito)}
                                    </td>    
                                    <td>
                                        {resumen.cantidadDebito}
                                    </td>  
                                </tr>
                                <tr> 
                                    <td>
                                        Crédito
                                    </td>
                                    <td>
                                        ${FormatoMoneda(resumen.totalCredito)}
                                    </td> 
                                    <td>
                                        {resumen.cantidadCredito}
                                    </td>     
                                </tr>
                                <tr> 
                                    <td>
                                        Transferencia
                                    </td>
                                    <td>
                                        ${FormatoMoneda(resumen.totalTransferencia)}
                                    </td> 
                                    <td>
                                        {resumen.cantidadTransferencia}
                                    </td>    
                                </tr>
                                <tr> 
                                    <td>
                                        Otros
                                    </td>
                                    <td>
                                        ${FormatoMoneda(resumen.totalOtro)}
                                    </td>   
                                    <td>
                                        {resumen.cantidadOtro}
                                    </td>   
                                </tr>
                                
                            </tbody>
                </table>      
            </div> 
        </div> 
        
        </div>:''}
    </div>
)

}
export default ReporteOperacionVendedor;